import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import dayjs from 'dayjs';
import { clientStatusMapToServerStatus, serverStatusMapToClientStatus } from '../../model/helper';
import type { HistoryRecord, PostCampaignStatus } from '../../model/types';

export type GetHistoriesReq = {
  date?: {
    end: number;
    start: number;
  };
  limit?: number;
  page?: number;
  status?: PostCampaignStatus;
};
export type GetHistoriesRes = {
  histories: {
    accountName: string;
    campaignName: string;
    historyRecordUuid: string;
    status: HistoryRecord['status'];
    statusTime: Date | null;
  }[];
  meta: {
    totalCount: number;
    totalPage: number;
  };
};

export const getHistories = async (params: GetHistoriesReq): Promise<GetHistoriesRes> => {
  const { date, status = 'all', page = 1, limit = 20 } = params;

  const { data: response } = await serviceApi.campaign.getParticipateInPostCampaign(
    withServiceRequestDefaults({
      historyStatus: status !== 'all' ? clientStatusMapToServerStatus(status) : status,
      ...(date && { endDate: date.end, startDate: date.start }),
      limit,
      page,
    }),
  );

  return {
    histories: response.data.map(
      ({ postViewingRecordUuid, name, historyStatus, failReason, snsId, statusTime }) => ({
        accountName: snsId,
        campaignName: name,
        historyRecordUuid: postViewingRecordUuid,
        status: serverStatusMapToClientStatus(historyStatus, failReason),
        statusTime: dayjs(statusTime).toDate(),
      }),
    ),
    meta: {
      totalCount: response.meta.totalCount,
      totalPage: Math.ceil(response.meta.totalCount / limit),
    },
  };
};
